import React from "react";
import i18next from "i18next";
import Button from "~assets/js/components/Button";
import Headline from "~assets/js/components/Typography/Headline";

const Partners = () => {
    return (
        <div className="franchise-academy-partners">
            <div className="container">
                <Headline size={2} className="franchise-academy-partners-title">
                    {i18next.t("franchise.academy.partners.title")}
                </Headline>
                <div className="franchise-academy-partners__content">
                    <div className="left">
                        <div className="image"></div>
                        <div className="content">
                            <p>
                                {i18next.t(
                                    "franchise.academy.partners.left.content"
                                )}
                            </p>
                        </div>
                        <div className="note">
                            <p>
                                {i18next.t(
                                    "franchise.academy.partners.left.note"
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="right">
                        <div className="image"></div>
                        <div className="content">
                            <p>
                                {i18next.t(
                                    "franchise.academy.partners.right.content"
                                )}
                            </p>
                        </div>
                        <div className="note">
                            <p>
                                {i18next.t(
                                    "franchise.academy.partners.right.note"
                                )}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="academy-button">
                    <Button
                        href="/franchise-formular"
                        size="SM"
                        variant="primary"
                        label={i18next.t("franchise.banner.hero.cta")}
                    />
                </div>
            </div>
        </div>
    );
};

export default Partners;
